/** Normaliza URLs de fotos de medidas (BD / Nest / nginx). */

export function resolveMeasurementPhotoSrc(url: string | null | undefined): string {
  const raw = String(url || '').trim()
  if (!raw) return ''
  if (/^(https?:|blob:|data:)/i.test(raw)) return raw
  // Path canónico que nginx reescribe → Nest GET /measurements/photo/:file
  if (raw.startsWith('/uploads/measurements/')) return raw
  if (raw.includes('/measurements/photo/')) {
    const name = raw.split('/').pop() || ''
    return name ? `/uploads/measurements/${name}` : raw
  }
  // Solo filename
  if (!raw.includes('/')) return `/uploads/measurements/${raw.replace(/[^a-zA-Z0-9._-]/g, '')}`
  return raw.startsWith('/') ? raw : `/${raw}`
}

/** Lee photoUrl / photo_url (camel o snake) de un registro de historial. */
export function measurementPhotoUrls(record: Record<string, unknown> | null | undefined): string[] {
  if (!record || typeof record !== 'object') return []
  const keys = [
    'photoUrl', 'photoUrl2', 'photoUrl3', 'photoUrl4',
    'photo_url', 'photo_url_2', 'photo_url_3', 'photo_url_4',
  ]
  const out: string[] = []
  for (const k of keys) {
    const src = resolveMeasurementPhotoSrc(record[k] as string)
    if (src && !out.includes(src)) out.push(src)
  }
  return out
}
